import type { Routes } from '@angular/router'
import type { ProductConfiguration } from '@awork/_shared/services/product/product-configuration'
import { createAworkRoutes } from './products/awork.routes'
import { createaworkAIRoutes } from './products/aworkAI.routes'

/**
 * Creates the route composition for the selected product.
 * @param {ProductConfiguration} productConfiguration Selected product configuration.
 * @returns {Routes} Routes registered for the product.
 */
export function createAppRoutes(productConfiguration: ProductConfiguration): Routes {
  if (productConfiguration.id === 'aworkAI') {
    return createaworkAIRoutes(productConfiguration)
  }

  return createAworkRoutes(productConfiguration)
}
